import script from "./CommonSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonSearch.vue?vue&type=script&lang=ts&setup=true"

import "./CommonSearch.vue?vue&type=style&index=0&id=6b269326&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b269326"]])

export default __exports__